import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import VueMeta from 'vue-meta'
import 'element-ui/lib/theme-chalk/index.css';
// 重置样式 reset.css
import './assets/css/reset.css'

import './rem.js'
import './assets/font/iconfont.css'

import BaiduMap from 'vue-baidu-map'
import $ from 'jquery'
window.jQuery = $;
window.$ = $;

Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.use(BaiduMap, {
  ak: 'XALQoWqGADldBr9X0ResVnGZL4HYn1r3'
})
Vue.use(VueMeta, {
  keyName: 'metaInfo', // 组件内使用的选项名
})
// 全局加载百度统计（仅在生产环境生效）
console.log(process.env.NODE_ENV);

if (process.env.NODE_ENV === 'production') {

  // const script = document.createElement('script')
  // script.src = 'https://hm.baidu.com/hm.js?1941571ff3c8f6515f9023b593ed19b8'
  // document.head.appendChild(script)
  var _hmt = _hmt || [];
  (function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?1941571ff3c8f6515f9023b593ed19b8";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
